import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { CreateClientMarketFixConnectionMutationResponse, CreateClientMarketFixConnectionPathParams, CreateClientMarketFixConnection400 } from "../types/CreateClientMarketFixConnection";
import type { UseMutationOptions } from "@tanstack/react-query";

 type CreateClientMarketFixConnectionClient = typeof client<CreateClientMarketFixConnectionMutationResponse, CreateClientMarketFixConnection400, never>;
type CreateClientMarketFixConnection = {
    data: CreateClientMarketFixConnectionMutationResponse;
    error: CreateClientMarketFixConnection400;
    request: never;
    pathParams: CreateClientMarketFixConnectionPathParams;
    queryParams: never;
    headerParams: never;
    response: CreateClientMarketFixConnectionMutationResponse;
    client: {
        parameters: Partial<Parameters<CreateClientMarketFixConnectionClient>[0]>;
        return: Awaited<ReturnType<CreateClientMarketFixConnectionClient>>;
    };
};
/**
 * @description Creates a new FIX connection for a clients market
 * @summary Create FIX connection
 * @link /api/clients/:clientCode/markets/:marketCode/connections/fix
 */
export function useCreateClientMarketFixConnection(clientCode: CreateClientMarketFixConnectionPathParams["clientCode"], marketCode: CreateClientMarketFixConnectionPathParams["marketCode"], options: {
    mutation?: UseMutationOptions<CreateClientMarketFixConnection["response"], CreateClientMarketFixConnection["error"], CreateClientMarketFixConnection["request"]>;
    client?: CreateClientMarketFixConnection["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async () => {
            const res = await client<CreateClientMarketFixConnection["data"], CreateClientMarketFixConnection["error"], CreateClientMarketFixConnection["request"]>({
                method: "post",
                url: `/api/clients/${clientCode}/markets/${marketCode}/connections/fix`,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}